import React from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { LayoutProvider } from "../Layouts/LayoutContext";
import SetupPanel from "../Projects/panels/SetupPanel";
import ViewerPanel from "../Projects/panels/ViewerPanel";     // ADAPT
import DevicesPanel from "../Projects/panels/Devices/DevicesPanel";
import "../Layouts/Layout.css";

const SETUP_TABS = ["enclosure", "scenario", "climatization"];

// projectId from the path (/embed/:projectId/setup) or the query (?projectId=...)
function EmbedFrame({ children }) {
  const routeParams = useParams();
  const [params] = useSearchParams();
  const projectId = routeParams.projectId || params.get("projectId");

  if (!projectId) return <p className="pl-hint">Missing projectId.</p>;

  return (
    <div className="pl-embed">
      <LayoutProvider projectId={projectId}>{children}</LayoutProvider>
    </div>
  );
}

// Setup panel options via URL:
//   ?tab=enclosure|scenario|climatization  -> tab shown first
//   ?hideTabs=1                            -> hide the tab bar
export const EmbedSetup = () => {
  const [params] = useSearchParams();
  const tabParam = params.get("tab");
  const initialTab = SETUP_TABS.includes(tabParam) ? tabParam : undefined;
  const hideTabs = params.get("hideTabs") === "1";

  return (
    <EmbedFrame>
      <SetupPanel initialTab={initialTab} hideTabs={hideTabs} />
    </EmbedFrame>
  );
};

export const EmbedViewer = () => <EmbedFrame><ViewerPanel /></EmbedFrame>;
export const EmbedDevices = () => <EmbedFrame><DevicesPanel /></EmbedFrame>;
